import { animated, useTransition } from "@react-spring/web";
import { useAtom } from "jotai";
import React from "react";
import { hitsAtom } from "../atoms";

export const IntroSection2 = ({ active }) => {
  const trans = useTransition(active, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    delay: 1000,
  });

  return (
    <>
      {trans(
        (style, item) =>
          item && (
            <animated.section
              className="scene-section intro-section"
              style={style}
            >
              <h2>Harder!</h2>
            </animated.section>
          )
      )}
    </>
  );
};
